/**
 * Shared step metadata for DXP registration sidebar + compact horizontal stepper.
 */

export type WizardNavStepMeta = {
  key: number;
  label: string;
  /** Second line under the title on the horizontal stepper */
  subtitle: string;
};

export function getWizardNavSteps(
  selectedRegisterCompanyType: string | null | undefined,
): WizardNavStepMeta[] {
  const base: WizardNavStepMeta[] = [
    {
      key: 1,
      label: "Select your company",
      subtitle: "Domain & type",
    },
    {
      key: 2,
      label: "Adobe ID verification",
      subtitle: "Sign in",
    },
    {
      key: 3,
      label: "User profile",
      subtitle: "Your details",
    },
  ];

  if (selectedRegisterCompanyType === "subsidaryCompany") {
    return [
      ...base,
      {
        key: 4,
        label: "Company information",
        subtitle: "Business details",
      },
    ];
  }

  if (selectedRegisterCompanyType === "standaloneCompany") {
    return [
      ...base,
      {
        key: 4,
        label: "Company information",
        subtitle: "Business details",
      },
      {
        key: 5,
        label: "Membership options",
        subtitle: "Choose level",
      },
    ];
  }

  return base;
}
